import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * TypographyShowcase Component
 * Displays typography scale with theme styling
 */
const TypographyShowcase = ({ theme }) => {
  return (
    <Grid size={{ xs: 12 }}>
      <Typography variant="subtitle2" gutterBottom>
        Typography Scale
      </Typography>
      <Box sx={{ backgroundColor: theme.surface_color, p: 2, borderRadius: 1 }}>
        <Typography
          variant="h1"
          sx={{
            color: theme.primary_color,
            fontFamily: theme.font_family,
            fontSize: theme.heading_font_size,
            mb: 1,
          }}
        >
          Heading 1
        </Typography>
        <Typography
          variant="h2"
          sx={{
            color: theme.secondary_color,
            fontFamily: theme.font_family,
            mb: 1,
          }}
        >
          Heading 2
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: theme.text_color,
            fontFamily: theme.font_family,
            fontSize: theme.font_size,
            mb: 1,
          }}
        >
          Body text - Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          This preview shows how your content will appear with the selected
          theme.
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: theme.text_color,
            fontFamily: theme.font_family,
            opacity: 0.7,
          }}
        >
          Caption text - Smaller supporting text
        </Typography>
      </Box>
    </Grid>
  );
};

TypographyShowcase.propTypes = {
  theme: PropTypes.object.isRequired,
};

export default TypographyShowcase;
